import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: signalR.HubConnection;

  constructor(private configService: ConfigService) {}

  public startConnection = (path: string) => {
    this.hubConnection = new signalR.HubConnectionBuilder().withUrl(this.configService.getApiPath(`hub/${path}`)).build();

    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch((err) => console.log('Error while starting connection: ' + err));
  };

  public addListener = <T>(hubMethod: string): Observable<T> => {
    return new Observable<T>((obs) => {
      this.hubConnection.on(hubMethod, (data) => {
        obs.next(data);
      });
    });
  };
}
